export default "__VITE_ASSET__CDmQY4lu__"